export default "__VITE_ASSET__DEFmiqjR__"